module.exports = __webpack_public_path__ + "static/termitals-my.9dd5f60d94c3b42c9b645acd6d352f63.png";